import type { TranslationKey } from '@/i18n/dictionary';

/**
 * The copy of `New user / 12 · Your next steps` (it was `10a`) — and which of it is ours [KAP-5a].
 *
 * **Every word on this screen now goes through the dictionary, in English and Spanish.** Decision 0436
 * (the Operator, 2026-10-02) rules this screen's static copy the kiosk app's OWN copy under 0328 rule 1: its
 * Spanish is machine-translated and **reviewed by ISS** (OQ-134, open — a human gate that does not block
 * the build), and it is never required to be ISS-authored. It is not application or legal text (0328
 * rule 2), so `src/i18n/CLAUDE.md`'s no-machine-translation rule does not reach it. Until 0436 this file
 * held the English outside the dictionary and reported its Spanish as owed from ISS; that posture is
 * retired, and the strings are the `finish.*` keys in `src/i18n/dictionary.ts`.
 *
 * The English is the frame's `characters`, read live on 2026-10-05 from the prominence frames
 * [12860:29119 desktop · 29199 iPad · 29279 mobile, file version 2405795076362635249]. ISS owns every
 * English word on the screen [0360; 0297] — except the one string below.
 */

/**
 * ⭐ **RECORDED COPY — the only string on this screen that Rootstrap wrote** [decision 0360, authored under
 * 0350; it closed the wording half of OQ-137, which 0302 had raised].
 *
 * It tells the candidate the next step happens on their OWN phone, which the screen did not say clearly
 * enough [0302]. EN and ES are 0360's literals, character for character, and the Spanish is rendered AS
 * RECORDED rather than re-translated [0436 point 2]. **Provisional:** when ISS words this message, their
 * text replaces both values of the key named here — a one-line change per language — and if a frame ever
 * draws different words for it, the frame governs [0350].
 *
 * Kept as a map of KEYS rather than strings so the dictionary stays the single place a language lives; the
 * enrolment feature's `RECORDED_COPY` is English-only and predates that need.
 */
export const RECORDED_COPY = {
  personalDevice: 'finish.personalDevice',
} as const satisfies Readonly<Record<string, TranslationKey>>;
